import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

const SubscriptionReminderModal = () => {
  const { status, showReminderNow, dismissReminder } = useSubscription();
  const navigate = useNavigate();

  if (!status || status.exempt) return null;

  const days = status.daysRemaining;
  const expired = status.expired;
  const isGrace = status.inGrace;

  const title = expired
    ? 'Subscription expired'
    : isGrace
      ? 'Subscription in grace period'
      : 'Subscription ending soon';

  const body = expired
    ? `Your ${status.planName || 'subscription'} has expired. Admin features are locked until you renew.`
    : (typeof days === 'number'
        ? `Your ${status.planName || 'subscription'} ${days <= 0 ? 'ends today' : `ends in ${days} day${days === 1 ? '' : 's'}`}. Renew now to avoid disruption.`
        : `Your ${status.planName || 'subscription'} ends soon.`);

  const bg = expired ? '#dc2626' : isGrace ? '#d97706' : '#2563eb';

  const goRenew = () => {
    dismissReminder();
    navigate('/renew-subscription');
  };

  return (
    <Modal show={showReminderNow} onHide={dismissReminder} centered backdrop="static">
      <Modal.Body style={{ padding: 0, borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ background: bg, color: '#fff', padding: '24px 24px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>
            <i className={`bi ${expired ? 'bi-exclamation-octagon-fill' : 'bi-bell-fill'}`} />
          </div>
          <h5 style={{ margin: 0, fontWeight: 800 }}>{title}</h5>
        </div>
        <div style={{ padding: '22px 24px 8px', textAlign: 'center' }}>
          <p style={{ margin: 0, color: '#334155', fontSize: 14 }}>{body}</p>
          {status.endDate && (
            <p style={{ margin: '10px 0 0', color: '#64748b', fontSize: 12 }}>
              End date: <strong>{new Date(status.endDate).toLocaleDateString()}</strong>
            </p>
          )}
        </div>
        <div style={{ padding: '16px 24px 22px', display: 'flex', gap: 10, justifyContent: 'center' }}>
          <Button variant="outline-secondary" onClick={dismissReminder} style={{ minWidth: 120, borderRadius: 10, fontWeight: 600 }}>
            Later
          </Button>
          <Button variant="primary" onClick={goRenew} style={{ minWidth: 140, borderRadius: 10, fontWeight: 700 }}>
            Renew now
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionReminderModal;
